import React, { useEffect, useContext, useState, useMemo } from "react";
import Footer from "../components/footer";
import EmployeeAttendanceWeekTable from "../components/employee_attendance_week_table";
import Toggle from "../components/toggle";
import { listOrganizationalUnits, getOrganizationalUnit } from "../services/api_org_unit";
import { AuthContext } from "../contexts/auth";
import EmployeeAttendanceMonthTable from "../components/employee_attendance_month_table";
import ComboboxAutocomplete from "../components/combobox_autocomplete";
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import EmployeeAttendanceTable from "../components/employee_attendance_table";
import Fetching from "../components/fetching";
import CheckPermissions from "../components/check_permissions";
import ListBoxPageSize from "../components/listbox_pase_size";
import { Link } from "wouter";
import PopoverComponentCustom from "../components/popover_component";
import SchedulerContextBar from "../components/scheduler_context_bar";
import V2Toggle from "../components/v2_toggle";
import AttendanceControlsBar from "../components/attendance_controls_bar";
import moment from "moment";

  
function ShiftCalendar() {
    const { token, profile } = useContext(AuthContext);
    const [selectedOption, setSelectedOption] = useState(() => {
        if (profile.customer_type !== 'employee') {
            return 'GIORNALIERO';
        }

        return profile?.employee?.permissions?.includes('hr.view_shifts_all') || 
               profile?.employee?.permissions?.includes('hr.view_shifts_ou') ||
               profile?.employee?.permissions?.includes('hr.manage_shifts_all') || 
               profile?.employee?.permissions?.includes('hr.manage_shifts_ou')

            ? 'GIORNALIERO'
            : 'SETTIMANALE';
    });
    const [selectedUnitId, setSelectedUnitId] = useState(null);
    const [units, setUnits] = useState([]);
    const [unitData, setUnitData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [totalResult, setTotalResult] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [abortController, setAbortController] = useState(null);
    const [selectedDate, setSelectedDate] = useState(() => new Date());
    const [selectedTimeRange, setSelectedTimeRange] = useState("day");

    const [currentDate, setCurrentDate] = useState(new Date());

    const isProfileComplete = profile.has_complete_profile;

    const selectedUnit = useMemo(
        () => units.find(u => u.id === selectedUnitId) || null,
        [units, selectedUnitId]
    );

    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const selectedEmployeeIds = useMemo(
        () => selectedEmployees.map(e => e.id),
        [selectedEmployees]
    );

    const abortCurrentFetch = () => {
        abortController?.abort();
    };

    const handleToggleChange = (option) => {
        if (option === selectedOption) {
            return;
        }

        abortCurrentFetch();
        setSelectedOption(option);
    };

    const { startISO, endISO } = React.useMemo(() => {
        if (selectedOption === "GIORNALIERO") {
            const m = moment(currentDate);
            const s = m.clone().startOf("day");
            const e = m.clone().endOf("day");          // stesso giorno
            return { startISO: s.format("YYYY-MM-DD"), endISO: e.format("YYYY-MM-DD") };
        }
        if (selectedOption === "SETTIMANALE") {
            // settimana ISO: lunedì → domenica
            const s = moment(currentDate).startOf("isoWeek");
            const e = moment(currentDate).endOf("isoWeek");
            return { startISO: s.format("YYYY-MM-DD"), endISO: e.format("YYYY-MM-DD") };
        }
        // MENSILE
        const s = moment(currentDate).startOf("month");
        const e = moment(currentDate).endOf("month");
        return { startISO: s.format("YYYY-MM-DD"), endISO: e.format("YYYY-MM-DD") };
    }, [selectedOption, currentDate]);

    // useEffect(() => {
    //     const controller = new AbortController();
    //     const signal = controller.signal;

    //     async function getData() {
    //         try {
    //             const response = await getEmployeesWithActiveContract(token, null, 'true', signal, page, pageSize);
    //             const employeesArray = Array.isArray(response.results) ? response.results : [];
    
    //             const sortedResponse = employeesArray.sort((a, b) => a.cf.localeCompare(b.cf));
    
    //             setTotalResult(response.count);
    
    //             setGlobalEmployees(sortedResponse);
    //             setFilteredEmployees(sortedResponse);             
    
    //         } catch (error) {
    //             if (error.name !== 'AbortError') {
    //                 console.log(error);
    //             }
    //         }
    //     }
    
    //     if (token) {
    //         getData();
    //     }
    
    //     return () => {
    //         controller.abort();
    //     };
    // }, [token, page, pageSize]);


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize); 
        setPage(1); 
    };

    const handleNextPage = () => {
        if (nextPage) {
          setPage(prevPage => prevPage + 1);
        }
    };
    
    const handlePreviousPage = () => {
    if (prevPage) {
        setPage(prevPage => prevPage - 1);
    }
    };

    useEffect(() => {
        const fetchUnits = async () => {
            setIsLoading(true);
            setIsError(false);

            try {
                const response = await listOrganizationalUnits(token, true, null, 'attendance');
                const list = response.data || [];
                setUnits(list);
                
                if (!selectedUnitId && list.length > 0) {
                    setSelectedUnitId(list[0].id);
                }
            } catch (error) {  
                console.error('Error fetching units:', error);
                if (error.response && error.response.status !== 402) {
                    setIsError(true);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchUnits();
    }, [token]);

    const handleParentChange = (selectedParent) => {
        abortCurrentFetch();
        if (selectedParent) {
            const newParentId = selectedParent.id;
            setSelectedUnitId(newParentId);
            setPage(1);
        } else {
            setSelectedUnitId(null);
            setUnitData(null);
        }
    };

    const handleResetUnitSelection = () => {
        abortCurrentFetch();
        setSelectedUnitId(null);
        setPage(1);
    };

    const handleEmployeesChange = (nextArray) => {
        setSelectedEmployees(nextArray);
        setPage(1);
    };


    if (isLoading) return <Fetching />
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="flex flex-col min-h-screen">
        <PopoverComponentCustom title='Calendario Presenze' />

        {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email === profile?.the_real_user_email && (
            <div className="w-full">
            <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                <p className="text-center text-sm font-semibold">
                Il profilo non è completo. <br />
                Compila i campi mancanti{" "}
                <Link to="/profilo/fatturazione" className="text-indigo-600 hover:text-indigo-800 underline">
                    cliccando qui
                </Link>
                </p>
            </div>
            </div>
        )}

        <main className="flex-grow mt-4 pb-8">
            <div className="mx-auto w-full max-w-[1600px] px-4 md:px-6">
                <div className="mb-4">
                    <SchedulerContextBar
                        className="w-full"
                        units={units}
                        selectedUnit={selectedUnit}
                        onSelectUnit={handleParentChange}
                        onResetUnit={handleResetUnitSelection}
                        isUnitsLoading={false}
                        token={token}
                        selectedEmployees={selectedEmployees}
                        onEmployeesChange={handleEmployeesChange}
                        pageSize={pageSize}
                        onPageSizeChange={handlePageSizeChange}
                        contractStartDate={startISO}
                        contractEndDate={endISO}
                    />
                </div>

                <div className="mb-0">
                    <AttendanceControlsBar
                        className="w-full"
                        mode={selectedOption}
                        onModeChange={setSelectedOption}
                        date={currentDate}
                        onDateChange={setCurrentDate}
                    />
                </div>
                             
                {selectedOption === "GIORNALIERO" && (
                    <CheckPermissions permissionsToCheck={['hr.view_shifts_all','hr.view_shifts_ou','hr.manage_shifts_ou','hr.manage_shifts_all','hr.view_inouts_ou','hr.view_inouts_all','hr.manage_inouts_ou','hr.manage_inouts_all']}>
                    <EmployeeAttendanceTable
                        selectedUnit={selectedUnit}
                        employeeIds={selectedEmployeeIds}
                        page={page}
                        setTotalResult={setTotalResult}
                        pageSize={pageSize}
                        setNextPage={setNextPage}
                        setPrevPage={setPrevPage}
                        onAbortControllerReady={setAbortController}
                        date={currentDate}
                    />
                    </CheckPermissions>
                )}

                {selectedOption === "SETTIMANALE" && (
                    <CheckPermissions permissionsToCheck={['hr.view_attendance_all','hr.view_attendance_ou']}>
                    <EmployeeAttendanceWeekTable
                        selectedUnit={selectedUnit}
                        employeeIds={selectedEmployeeIds}
                        page={page}
                        totalResult={totalResult}
                        setTotalResult={setTotalResult}
                        pageSize={pageSize}
                        setNextPage={setNextPage}
                        setPrevPage={setPrevPage}
                        onAbortControllerReady={setAbortController}
                        date={currentDate}
                    />
                    </CheckPermissions>
                )}

                {selectedOption === "MENSILE" && (
                    <CheckPermissions permissionsToCheck={['hr.view_attendance_all','hr.view_attendance_ou']}>
                    <EmployeeAttendanceMonthTable
                        selectedUnit={selectedUnit}
                        selectedEmployees={selectedEmployeeIds}
                        page={page}
                        totalResult={totalResult}
                        setTotalResult={setTotalResult}
                        pageSize={pageSize}
                        setNextPage={setNextPage}
                        setPrevPage={setPrevPage}
                        onAbortControllerReady={setAbortController}
                        date={currentDate}
                    />
                    </CheckPermissions>
                )}
            

                {totalResult > pageSize && (
                <div className="flex justify-between mt-6">
                    <button
                    className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    onClick={handlePreviousPage}
                    disabled={!prevPage}
                    >
                    Precedente
                    </button>
                    <span className='text-sm font-medium text-gray-900'>
                    Pagina {page} di {Math.ceil(totalResult / pageSize)}
                    </span>
                    <button
                    className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    onClick={handleNextPage}
                    disabled={!nextPage}
                    >
                    Successivo
                    </button>
                </div>
                )}
            </div>
        </main>

        <Footer />
        </div>
    );
}

export default ShiftCalendar;
